import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Plus, Pencil, Trash2 } from "lucide-react";
import ImageUpload from "@/components/ImageUpload";
import { resolveImage } from "@/lib/image";

const EMPTY = { title: "", description: "", image: "", button_text: "Learn More", button_link: "/", target_page: "/", frequency: "once_per_session", active: true, priority: 1 };

export default function AdminPopups() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/popup-ads?active_only=false").then(({data}) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const save = async () => {
    try {
      if (editing.id) await api.put(`/popup-ads/${editing.id}`, editing);
      else await api.post("/popup-ads", editing);
      toast.success("Saved"); setEditing(null); load();
    } catch { toast.error("Save failed"); }
  };
  const del = async (id) => { if (!confirm("Delete?")) return; await api.delete(`/popup-ads/${id}`); load(); };
  return (
    <div data-testid="admin-popups">
      <div className="flex justify-between mb-5"><h1 className="font-heading text-3xl text-[#FAF9F6]">Popup Ads</h1>
      <button onClick={() => setEditing({...EMPTY})} className="btn-chow"><Plus className="w-4 h-4 inline"/> New</button></div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map(p => (
          <div key={p.id} className="admin-card overflow-hidden">
            {p.image && <div className="h-32 bg-cover bg-center" style={{backgroundImage: `url(${resolveImage(p.image)})`}}/>}
            <div className="p-4">
              <span className={`badge-${p.active ? 'fresh' : 'royal'}`}>{p.active ? "ACTIVE" : "OFF"}</span>
              <h3 className="font-heading text-xl text-[#D4AF37] mt-2">{p.title}</h3>
              <p className="text-xs text-[#FAF9F6]/60">{p.description}</p>
              <div className="flex justify-end gap-2 mt-3">
                <button onClick={() => setEditing(p)} className="text-[#D4AF37]"><Pencil className="w-4 h-4"/></button>
                <button onClick={() => del(p.id)} className="text-[#E8A87C]"><Trash2 className="w-4 h-4"/></button>
              </div>
            </div>
          </div>
        ))}
      </div>
      {editing && (
        <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4">
          <div className="admin-card p-6 w-full max-w-md max-h-[90vh] overflow-y-auto">
            <h3 className="font-heading text-2xl text-[#D4AF37] mb-3">{editing.id ? "Edit" : "New"} popup</h3>
            <div className="space-y-2 text-sm">
              <input value={editing.title} onChange={(e) => setEditing({...editing, title: e.target.value})} placeholder="Title" className="w-full bg-[#0B0E14] border border-[#D4AF37]/30 px-3 py-2 rounded text-[#FAF9F6]"/>
              <textarea rows={2} value={editing.description} onChange={(e) => setEditing({...editing, description: e.target.value})} placeholder="Description" className="w-full bg-[#0B0E14] border border-[#D4AF37]/30 px-3 py-2 rounded text-[#FAF9F6]"/>
              <ImageUpload
                value={editing.image}
                onChange={(url) => setEditing({...editing, image: url})}
                recommendedSize="800 × 480"
                aspect="aspect-[5/3]"
                testId="popup-image"
              />
              <div className="grid grid-cols-2 gap-2">
                <input value={editing.button_text} onChange={(e) => setEditing({...editing, button_text: e.target.value})} placeholder="Button text" className="bg-[#0B0E14] border border-[#D4AF37]/30 px-3 py-2 rounded text-[#FAF9F6]"/>
                <input value={editing.button_link} onChange={(e) => setEditing({...editing, button_link: e.target.value})} placeholder="Button link" className="bg-[#0B0E14] border border-[#D4AF37]/30 px-3 py-2 rounded text-[#FAF9F6]"/>
              </div>
              <label className="flex gap-2 text-xs text-[#FAF9F6]"><input type="checkbox" checked={editing.active} onChange={(e) => setEditing({...editing, active: e.target.checked})}/> Active</label>
            </div>
            <div className="flex gap-2 mt-4">
              <button onClick={save} className="btn-chow flex-1">Save</button>
              <button onClick={() => setEditing(null)} className="btn-chow-outline flex-1">Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
